import { createFileRoute } from '@tanstack/react-router';
import { AdminTripsList } from '@/components/AdminTripsList';
import { z } from 'zod';

const tripsSearchSchema = z.object({
  search: z.string().optional(),
  createTrip: z.boolean().optional(),
  quickStart: z.boolean().optional(),
  tab: z.enum(['draft', 'scheduled', 'complete']).optional(),
});

export const Route = createFileRoute('/_auth/operations/trips/')({
  validateSearch: tripsSearchSchema,
  component: AdminTripsListRoute,
});

function AdminTripsListRoute() {
  const { search, createTrip, quickStart, tab } = Route.useSearch();
  return (
    <AdminTripsList initialSearch={search} createTrip={createTrip} quickStart={quickStart} initialTab={tab} />
  );
}
